import SelectGroup from "../../components/Forms/SelectGroup/SelectGroup.tsx";
import { useState } from "react";
import usePolicyForm from "../../hooks/usePolicyForm.tsx";
import DatePicker from "../../components/Forms/DatePicker/DatePicker.tsx";
import moment from "moment/moment";
import PolicyService from "../../services/PolicyService/PolicyService.ts";
import { useAuth } from "../../provider/AuthProvider.tsx";
import FadeAlert, {
  FadeAlertType,
} from "../../components/FadeAlert/FadeAlert.tsx";
import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb.tsx";
import SectionHeader from "../../components/SectionHeader/SectionHeader.tsx";
import { inputClass, labelClass } from "../../constants/formStyles";

const NewPolicy = () => {
  const { jwt } = useAuth();
  const actions = {
    0: "Приемане",
    1: "Смяна на агент",
    2: "Анулиране",
    3: "Връщане в ЗК",
  };

  const [formState, setFormState] = useState({
    action: 0,
    agent: "",
    insuranceCompany: "",
    policyType: "",
    startValue: "",
    endValue: "",
    date: moment().format("DD/MM/YYYY"),
  });

  const [alert, setAlert] = useState<{ message: string; type: FadeAlertType }>({
    message: "",
    type: FadeAlertType.success,
  });

  const { agentOptions, policyTypes, insuranceCompanies } = usePolicyForm();

  const handleInputChange = (key: string, value: string | number) => {
    setFormState((prevState) => ({ ...prevState, [key]: value }));
  };

  const saveNewPolicyDocument = async () => {
    try {
      const response = await PolicyService.saveNewPolicy(formState, jwt);
      setAlert({ message: response, type: FadeAlertType.success });
    } catch (e) {
      setAlert({ message: e.message, type: FadeAlertType.error });
    }
  };

  return (
    <>
      <Breadcrumb pageName="Нови полици" />

      <FadeAlert
        alert={alert?.message}
        type={alert?.type}
        onClose={() => setAlert(null)}
      />
      <fieldset className="border-stroke dark:border-strokedark shadow-default dark:bg-boxdark mt-2 rounded-sm border bg-white">
        <SectionHeader title="Нови полици" />

        <div className="p-3 pt-1">
          <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">
            <div>
              <label className={labelClass}>Изберете действие</label>
              <SelectGroup
                placeholder="Изберете действие"
                options={actions}
                value={String(formState.action)}
                onChange={(selectedValue: string) => {
                  handleInputChange("action", Number(selectedValue));
                }}
              />
            </div>

            {policyTypes && (
              <div>
                <label className={labelClass}>Тип полица</label>
                <SelectGroup
                  placeholder="Изберете тип полица"
                  value={formState.policyType}
                  options={policyTypes}
                  onChange={(selectedValue: string) => {
                    handleInputChange("policyType", selectedValue);
                  }}
                />
              </div>
            )}

            <div>
              <label className={labelClass}>От номер</label>
              <input
                type="text"
                value={formState.startValue}
                onChange={(e) =>
                  handleInputChange("startValue", e.target.value)
                }
                className={inputClass}
              />
            </div>

            <div>
              <label className={labelClass}>До номер</label>
              <input
                type="text"
                value={formState.endValue}
                onChange={(e) => handleInputChange("endValue", e.target.value)}
                className={inputClass}
              />
            </div>

            {insuranceCompanies && (
              <div>
                <label className={labelClass}>Застрахователна компания</label>
                <SelectGroup
                  placeholder="Изберете ЗК"
                  value={formState.insuranceCompany}
                  options={insuranceCompanies}
                  onChange={(selectedValue: string) => {
                    handleInputChange("insuranceCompany", selectedValue);
                  }}
                />
              </div>
            )}

            {agentOptions && (
              <div>
                <label className={labelClass}>Агент</label>
                <SelectGroup
                  placeholder="Изберете агент"
                  value={formState.agent}
                  options={agentOptions}
                  onChange={(selectedValue: string) => {
                    handleInputChange("agent", selectedValue);
                  }}
                />
              </div>
            )}

            <div>
              <DatePicker
                label="Дата"
                onChange={(e) => handleInputChange("date", e.target.value)}
                value={formState.date}
                name="newPolicyDate"
              />
            </div>
          </div>

          <div className="mt-3 flex justify-center">
            <button
              onClick={(e) => {
                e.preventDefault();
                saveNewPolicyDocument();
              }}
              className="bg-primary flex w-1/6 justify-center rounded px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90"
            >
              Запис
            </button>
          </div>
        </div>
      </fieldset>
    </>
  );
};

export default NewPolicy;
